export const isAllowed = (user = {
  roles: []
}, rights = []) =>
  rights.some(right => right === USER ? true : user.roles.includes(right));

export const USER = 'USER'
export const ADMIN = 'ADMIN'
export const REPORTS = 'REPORTS'
export const SNAP_V2 = 'SNAP_V2'
export const CAR_FORM_V1 = 'CAR_FORM_V1'
export const CAR_FORM_V2 = 'CAR_FORM_V2'
export const CAR_FORM_V3 = 'CAR_FORM_V3'